/* Nova theme JS v5 — Premium DTC */
(function(){
  'use strict';

  /* Baştaki nöbetçi script bunu bekliyor: dikilmezse animasyonlar
     kapatılıp içerik görünür kılınır. Bkz. layout/theme.liquid. */
  window.__themeBoot = true;
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  // ============ SCROLL REVEAL & PREMIUM SECTION TRANSITIONS ============
  function initScrollReveal(scope) {
    const root = scope || document;
    const targets = root.querySelectorAll('.reveal, .reveal-stagger');
    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.02, rootMargin: '0px 0px -10px 0px' });

      targets.forEach(el => revealObserver.observe(el));
    } else {
      targets.forEach(el => el.classList.add('is-visible'));
    }
  }
  initScrollReveal(document);

  // Shopify Theme Editor'de bölüm eklendiğinde/düzenlendiğinde animasyonu anında tetikle
  document.addEventListener('shopify:section:load', function(e) {
    initScrollReveal(e.target);
    syncMarquees();
  });

  // ============ MARQUEE SPEED (constant px/sec on every device) ============
  function syncMarquees() {
    document.querySelectorAll('[data-marquee]').forEach(function(root){
      const group = root.querySelector('[data-marquee-group]');
      if (!group) return;
      const width = group.getBoundingClientRect().width;
      if (!width) return;
      const speed = 55; // px per second
      const duration = Math.max(12, Math.min(120, width / speed));
      root.style.setProperty('--marquee-duration', duration.toFixed(2) + 's');
    });
  }
  syncMarquees();
  window.addEventListener('load', syncMarquees);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncMarquees).catch(function(){});
  let marqueeTimer;
  window.addEventListener('resize', function(){
    clearTimeout(marqueeTimer);
    marqueeTimer = setTimeout(syncMarquees, 200);
  });



  // ============ ANIMATED COUNTERS ============
  function animateCounter(el) {
    const target = parseFloat(el.dataset.counterTarget || el.textContent.replace(/[^\d.-]/g, '')) || 0;
    const duration = parseInt(el.dataset.counterDuration || 1800, 10);
    const prefix = el.dataset.counterPrefix || '';
    const suffix = el.dataset.counterSuffix || '';
    const decimals = parseInt(el.dataset.counterDecimals || 0, 10);
    const startTime = performance.now();

    function step(now) {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const val = target * eased;
      el.textContent = prefix + val.toFixed(decimals) + suffix;
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(decimals) + suffix;
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-counter]').forEach(el => counterObserver.observe(el));
  }

  // ============ HEADER scroll state & SCROLL PROGRESS BAR ============
  const siteHeader = document.querySelector('.site-header');
  const scrollProgressEl = document.querySelector('[data-scroll-progress]');
  let scrollTicking = false;
  const updateScrollUI = () => {
    const y = window.scrollY || window.pageYOffset || 0;
    if (siteHeader) {
      siteHeader.classList.toggle('is-scrolled', y > 20);
    }
    if (scrollProgressEl) {
      const docHeight = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const pct = Math.min(100, Math.max(0, (y / docHeight) * 100));
      scrollProgressEl.style.setProperty('--sp-scroll-pct', pct.toFixed(2) + '%');
    }
    scrollTicking = false;
  };
  window.addEventListener('scroll', () => {
    if (!scrollTicking) {
      window.requestAnimationFrame(updateScrollUI);
      scrollTicking = true;
    }
  }, { passive: true });
  updateScrollUI();

  // Sayfalar arası gecikmesiz doğrudan geçiş (yapay fade-out gecikmesi kaldırıldı)
  window.addEventListener('pageshow', () => {
    document.body.classList.remove('sp-page-leaving');
  });

  // ============ MOBILE MENU ============
  const menuToggle = document.querySelector('.menu-toggle');
  const headerNav = document.querySelector('.header-nav');
  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', () => headerNav.classList.toggle('is-open'));
  }

  // ============ PARA BİÇİMİ ============
  // Fiyatlar mağazanın kendi para biçimiyle yazılır (Shopify yönetimi >
  // Ayarlar > Mağaza ayrıntıları; ör. "{{amount_with_comma_separator}} TL"
  // → 1.199,90 TL). Biçim cart-drawer.liquid'de data-money-format'ta durur.
  // Eskiden sabit "1199,90 TL" yazılıyordu: binlik ayıracı yoktu (Liquid'in
  // bastığı "1.199,90 TL"den farklıydı) ve TL dışı para biriminde yanlıştı.
  let paraKalibi = null;
  function paraKalibiGetir() {
    if (paraKalibi !== null) return paraKalibi;
    paraKalibi = '{{amount_with_comma_separator}} TL';
    const el = document.querySelector('[data-money-format]');
    const ham = el ? el.getAttribute('data-money-format') : '';
    if (ham && /\{\{\s*\w+\s*\}\}/.test(ham)) {
      // Biçim HTML içerebilir (ör. <span class=money>); düz metne çevrilir.
      // DOMParser belgesi etkisizdir: içindeki betik/görsel çalışmaz.
      try { paraKalibi = new DOMParser().parseFromString(ham, 'text/html').body.textContent || paraKalibi; }
      catch (e) { paraKalibi = ham; }
    }
    return paraKalibi;
  }

  function formatMoney(cents) {
    const kalip = paraKalibiGetir();
    const n = Math.round(Number(cents) || 0);
    const yaz = (basamak, binlik, ondalik) => {
      const parca = (Math.abs(n) / 100).toFixed(basamak).split('.');
      return (n < 0 ? '-' : '') + parca[0].replace(/\B(?=(\d{3})+(?!\d))/g, binlik) + (parca[1] ? ondalik + parca[1] : '');
    };
    let tutar;
    switch ((kalip.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1]) {
      case 'amount': tutar = yaz(2, ',', '.'); break;
      case 'amount_no_decimals': tutar = yaz(0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': tutar = yaz(0, '.', ','); break;
      case 'amount_with_space_separator': tutar = yaz(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': tutar = yaz(0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': tutar = yaz(2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': tutar = yaz(2, ' ', '.'); break;
      default: tutar = yaz(2, '.', ','); // amount_with_comma_separator
    }
    return kalip.replace(/\{\{\s*\w+\s*\}\}/, tutar);
  }

  // ============ EK ÜRÜN SATIRI — ürün sayfası ve sepet çekmecesi ortak ============
  // Satırın markup'ı: snippets/upsell-satir.liquid. Adet üst sınırı satırın
  // bağlı olduğu alanın data-upsell-max'ından okunur (iki yerin ayarı ayrı).
  function upsellUstSinir(row) {
    const alan = row.closest('[data-upsell]');
    return alan ? Math.max(1, parseInt(alan.dataset.upsellMax, 10) || 3) : 3;
  }

  function upsellDurum(row) {
    const check = row.querySelector('[data-upsell-check]');
    const select = row.querySelector('[data-upsell-variant]');
    const opt = select ? select.options[select.selectedIndex] : null;
    const id = select ? (opt && !opt.disabled ? parseInt(opt.value, 10) : null) : parseInt(row.dataset.variantId, 10);
    const qty = Math.min(upsellUstSinir(row), Math.max(1, parseInt(row.dataset.qty, 10) || 1));
    return { checked: !!(check && check.checked), id, qty };
  }

  function upsellAdetYaz(row, qty) {
    const max = upsellUstSinir(row);
    const q = Math.min(max, Math.max(1, qty));
    row.dataset.qty = q;
    const count = row.querySelector('[data-upsell-count]');
    if (count) count.textContent = q;
    row.querySelectorAll('[data-upsell-step]').forEach(b => {
      b.disabled = parseInt(b.dataset.upsellStep, 10) < 0 ? q <= 1 : q >= max;
    });
  }

  // Seçilen varyasyonun fiyatını/görselini satıra yazar (değerler Liquid'de
  // mağazanın para biçimiyle <option> üzerine hazırlandı)
  function upsellVaryasyonGoster(row) {
    const select = row.querySelector('[data-upsell-variant]');
    const opt = select ? select.options[select.selectedIndex] : null;
    if (!opt) return;
    const price = row.querySelector('[data-upsell-price]');
    const compare = row.querySelector('[data-upsell-compare]');
    const img = row.querySelector('[data-upsell-img]');
    const text = row.querySelector('[data-upsell-opt-text]');
    if (price) price.textContent = opt.dataset.price || '';
    if (compare) {
      compare.textContent = opt.dataset.compare || '';
      compare.hidden = !opt.dataset.compare;
    }
    if (img && opt.dataset.image) img.src = opt.dataset.image;
    if (text) text.textContent = opt.textContent;
  }

  // ============ CART DRAWER ============
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartCloseBtn = document.querySelector('.cart-drawer__close');
  const cartItemsEl = cartDrawer ? cartDrawer.querySelector('[data-cart-items]') : null;
  const cartTotalEl = cartDrawer ? cartDrawer.querySelector('.cart-drawer__total-amount') : null;
  const cartDiscountsEl = cartDrawer ? cartDrawer.querySelector('[data-cart-discounts]') : null;
  const cartMessageEl = cartDrawer ? cartDrawer.querySelector('[data-cart-message]') : null;
  const cartEmptyTpl = cartDrawer ? cartDrawer.querySelector('template[data-cart-empty]') : null;
  const cartUpsell = cartDrawer ? cartDrawer.querySelector('[data-cart-upsell]') : null;
  const cartUpsellRows = cartUpsell ? Array.from(cartUpsell.querySelectorAll('[data-upsell-row]')) : [];

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(t => t.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // --- Sepet durumu ---------------------------------------------------------
  // sunucuSepeti : Shopify'dan gelen son sepet (tek doğru kaynak).
  // istenenAdet  : müşterinin bastığı ama sunucuda henüz işlenmemiş adetler
  //                (satır anahtarı → adet). Ekran bunlarla ANINDA güncellenir,
  //                sunucunun cevabı gelince onunla düzeltilir.
  // İstekler tek sıradan gider (biri bitmeden diğeri başlamaz); art arda
  // basışlar 350 ms toplanıp TEK istekte gönderilir. Hızlı tıklamada adet
  // kaybolmaz, cevaplar karışmaz; ekranda her zaman en son cevap kalır.
  let sunucuSepeti = null;
  const istenenAdet = new Map();
  const yeniEklenenler = new Set(); // az önce eklenen ek ürünler (sepet tazelenene kadar gizli)
  let degisiklikSurumu = 0;         // her değişiklik isteğinde artar; daha eski /cart.js cevabı atılır
  let okumaSirasi = 0;              // üst üste /cart.js okumalarında yalnız sonuncusu işlenir
  let kuyruk = Promise.resolve();
  let suranIs = 0;
  let gonderZamanlayici = null;
  let bosalinca = [];

  // Üstü çizili (karşılaştırma) fiyatlar: /cart.js vermiyor. Çekmecedeki
  // JSON (sepetteki + ek ürünler) ve ürün sayfasının varyasyon listesinden.
  const karsilastirma = {};
  (window.productVariants || []).forEach(v => { if (v.compare_at_price > v.price) karsilastirma[v.id] = v.compare_at_price; });
  try {
    const kaynak = cartDrawer ? cartDrawer.querySelector('[data-cart-compare]') : null;
    if (kaynak) Object.assign(karsilastirma, JSON.parse(kaynak.textContent));
  } catch (e) { /* yoksa yalnız Shopify indirimleri çizilir */ }

  function sepetIstegi(yol, govde) {
    const kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const ayar = govde === undefined
      ? { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' }
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin', body: JSON.stringify(govde) };
    return fetch(kok + yol, ayar).then(
      r => r.json().catch(() => ({})).then(j => {
        if (!r.ok) {
          const hata = new Error(typeof j.description === 'string' && j.description ? j.description : 'Sepet güncellenemedi. Tekrar dene.');
          hata.status = r.status;
          throw hata;
        }
        return j;
      }),
      () => { throw new Error('Bağlantı kurulamadı. Tekrar dene.'); }
    );
  }

  function sepetMesgul() { return suranIs > 0 || gonderZamanlayici !== null; }
  function durumGuncelle() {
    const mesgul = sepetMesgul();
    if (cartDrawer) cartDrawer.classList.toggle('is-syncing', mesgul);
    if (!mesgul && bosalinca.length) {
      const isler = bosalinca;
      bosalinca = [];
      isler.forEach(fn => fn());
    }
  }
  // Sepeti değiştiren her iş bu sıradan geçer (bir önceki bitmeden başlamaz)
  function siraya(is) {
    suranIs++;
    durumGuncelle();
    const sonuc = kuyruk.then(is);
    kuyruk = sonuc.catch(() => {}).then(() => { suranIs--; durumGuncelle(); });
    return sonuc;
  }

  function mesajGoster(metin) {
    if (!cartMessageEl) return;
    if (cartMessageEl.textContent !== (metin || '')) cartMessageEl.textContent = metin || '';
    cartMessageEl.hidden = !metin;
  }

  function sepetiAl(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    sunucuSepeti = cart;
    yeniEklenenler.clear();
    renderCart();
  }

  // Sepeti sunucudan okur. Okuma sürerken bir değişiklik istendiyse ya da
  // daha yeni bir okuma başladıysa bu cevap eskidir ve atılır.
  function refreshCart() {
    const surum = degisiklikSurumu;
    const sira = ++okumaSirasi;
    return sepetIstegi('cart.js').then(cart => {
      if (surum !== degisiklikSurumu || sira !== okumaSirasi || suranIs > 0) return;
      sepetiAl(cart);
    }).catch(() => {});
  }

  // Sunucu sepeti + henüz işlenmemiş adetler = ekranda görünen sepet.
  // Adedi değişen satırın tutarı birim fiyatla tahmin edilir (satır indirimi
  // orantılı); kesin tutar sunucu cevabıyla gelir.
  function gorunum() {
    const c = sunucuSepeti;
    let fark = 0;
    let adet = 0;
    const items = [];
    c.items.forEach(item => {
      const istenen = istenenAdet.has(item.key) ? istenenAdet.get(item.key) : item.quantity;
      if (istenen <= 0) { fark -= item.final_line_price; return; }
      adet += istenen;
      if (istenen === item.quantity) { items.push(item); return; }
      const oran = istenen / item.quantity;
      const tahmin = Object.assign({}, item, {
        quantity: istenen,
        final_line_price: Math.round(item.final_line_price * oran),
        original_line_price: Math.round(item.original_line_price * oran),
        line_level_discount_allocations: (item.line_level_discount_allocations || []).map(a => Object.assign({}, a, { amount: Math.round(a.amount * oran) }))
      });
      fark += tahmin.final_line_price - item.final_line_price;
      items.push(tahmin);
    });
    return {
      items,
      item_count: adet,
      total_price: Math.max(0, (c.total_price || 0) + fark),
      cart_level_discount_applications: c.cart_level_discount_applications || []
    };
  }

  // Shopify görsel adresine genişlik ekler: 70px kutu için tam boy fotoğraf indirilmesin
  function kucukGorsel(url) {
    if (!url) return '';
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
    try { const u = new URL(url, location.href); u.searchParams.set('width', '160'); return u.href; } catch (e) { return url; }
  }

  // Üstü çizili tutar: Shopify indirimi uygulandıysa indirimsiz satır tutarı;
  // yoksa ürünün karşılaştırma fiyatı × adet (ürün sayfasıyla aynı mantık).
  function ustuCiziliTutar(item) {
    if (item.original_line_price > item.final_line_price) return item.original_line_price;
    const k = karsilastirma[item.variant_id];
    const birim = item.original_price != null ? item.original_price : item.price;
    return k && k > birim ? k * item.quantity : 0;
  }

  function metinYaz(el, metin) { if (el && el.textContent !== metin) el.textContent = metin; }

  function satirOlustur(key) {
    const el = document.createElement('div');
    el.className = 'cart-item';
    el.dataset.line = key;
    el.innerHTML =
      '<div class="cart-item__image"><img alt="" width="70" height="70" decoding="async" hidden></div>' +
      '<div class="cart-item__info">' +
        '<h4 class="cart-item__title"></h4>' +
        '<div class="cart-item__variant" hidden></div>' +
        '<div class="cart-item__prices"><span class="cart-item__price"></span><s class="cart-item__compare" hidden></s></div>' +
        '<ul class="cart-item__discounts" hidden></ul>' +
        '<div class="cart-item__controls">' +
          '<button type="button" class="cart-item__qty-btn" data-action="dec">−</button>' +
          '<span class="cart-item__qty" aria-live="polite"></span>' +
          '<button type="button" class="cart-item__qty-btn" data-action="inc">+</button>' +
          '<button type="button" class="cart-item__remove" data-action="remove">Kaldır</button>' +
        '</div>' +
      '</div>';
    return el;
  }

  // Satırı yerinde günceller: yalnız değişen yazı/görsel dokunulur, satır
  // yeniden kurulmaz (görsel yanıp sönmez, odak ve kaydırma yeri korunur).
  function satirYaz(el, item) {
    const q = (s) => el.querySelector(s);
    const ad = item.product_title || item.title || '';
    metinYaz(q('.cart-item__title'), ad);

    const varyasyon = !item.product_has_only_default_variant && item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const v = q('.cart-item__variant');
    metinYaz(v, varyasyon);
    v.hidden = !varyasyon;

    const img = q('.cart-item__image img');
    const src = kucukGorsel(item.image || (item.featured_image && item.featured_image.url) || '');
    if ((img.getAttribute('src') || '') !== src) {
      if (src) img.setAttribute('src', src); else img.removeAttribute('src');
    }
    img.hidden = !src;
    if (img.alt !== ad) img.alt = ad;

    metinYaz(q('.cart-item__price'), formatMoney(item.final_line_price));
    const ustu = ustuCiziliTutar(item);
    const s = q('.cart-item__compare');
    metinYaz(s, ustu ? formatMoney(ustu) : '');
    s.hidden = !ustu;

    // Satıra uygulanan Shopify indirimleri (otomatik indirim / kod): adı + tutarı
    const indirimler = (item.line_level_discount_allocations || [])
      .filter(a => a.amount > 0)
      .map(a => ((a.discount_application && a.discount_application.title) || 'İndirim') + ' (−' + formatMoney(a.amount) + ')');
    const ul = q('.cart-item__discounts');
    const imza = indirimler.join('|');
    if (ul.dataset.imza !== imza) {
      ul.dataset.imza = imza;
      ul.textContent = '';
      indirimler.forEach(t => { const li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
    }
    ul.hidden = !indirimler.length;

    metinYaz(q('.cart-item__qty'), String(item.quantity));
    const azalt = q('[data-action="dec"]');
    const artir = q('[data-action="inc"]');
    const kaldir = q('[data-action="remove"]');
    if (azalt.getAttribute('aria-label') !== ad + ' adedini azalt') {
      azalt.setAttribute('aria-label', ad + ' adedini azalt');
      artir.setAttribute('aria-label', ad + ' adedini artır');
      kaldir.setAttribute('aria-label', ad + ' — sepetten kaldır');
    }
  }

  function renderCart() {
    if (!sunucuSepeti) return;
    const g = gorunum();
    updateCartCount(g.item_count);
    if (!cartItemsEl) return;

    const eskiler = new Map();
    Array.from(cartItemsEl.children).forEach(el => { if (el.classList.contains('cart-item')) eskiler.set(el.dataset.line, el); });
    const bos = cartItemsEl.querySelector('.cart-empty');
    if (g.items.length && bos) bos.remove();
    g.items.forEach((item, i) => {
      const el = eskiler.get(item.key) || satirOlustur(item.key);
      eskiler.delete(item.key);
      satirYaz(el, item);
      if (cartItemsEl.children[i] !== el) cartItemsEl.insertBefore(el, cartItemsEl.children[i] || null);
    });
    let odakGitti = false;
    eskiler.forEach(el => { if (el.contains(document.activeElement)) odakGitti = true; el.remove(); });
    if (!g.items.length && !bos && cartEmptyTpl) cartItemsEl.appendChild(cartEmptyTpl.content.cloneNode(true));
    if (odakGitti && cartCloseBtn) cartCloseBtn.focus();

    // Sepet geneli indirimler (ör. "Tüm siparişte %10"): toplamın üstünde
    // ayrı satır; satır tutarlarının toplamı ile "Toplam" farkı açıklanır.
    if (cartDiscountsEl) {
      const satirlar = g.cart_level_discount_applications.filter(d => d.total_allocated_amount > 0);
      const imza = satirlar.map(d => (d.title || '') + ':' + d.total_allocated_amount).join('|');
      if (cartDiscountsEl.dataset.imza !== imza) {
        cartDiscountsEl.dataset.imza = imza;
        cartDiscountsEl.textContent = '';
        satirlar.forEach(d => {
          const satir = document.createElement('div');
          satir.className = 'cart-drawer__discount';
          const ad = document.createElement('span');
          ad.textContent = d.title || 'İndirim';
          const tutar = document.createElement('span');
          tutar.textContent = '−' + formatMoney(d.total_allocated_amount);
          satir.append(ad, tutar);
          cartDiscountsEl.appendChild(satir);
        });
      }
      cartDiscountsEl.hidden = !satirlar.length;
    }
    metinYaz(cartTotalEl, formatMoney(g.total_price));

    ekUrunleriGuncelle(g);
  }

  // Ek ürün satırları: sepette zaten olan ürün gizlenir; sepet boşsa ya da
  // gösterilecek satır kalmadıysa alan hiç görünmez.
  function ekUrunleriGuncelle(g) {
    if (!cartUpsell) return;
    const sepettekiler = new Set(g.items.map(i => String(i.product_id)));
    yeniEklenenler.forEach(id => sepettekiler.add(id));
    let gorunen = 0;
    cartUpsellRows.forEach(row => {
      const gizle = sepettekiler.has(row.dataset.productId);
      if (row.hidden !== gizle) row.hidden = gizle;
      if (!gizle) gorunen++;
    });
    const alanGizli = !g.items.length || !gorunen;
    if (cartUpsell.hidden !== alanGizli) cartUpsell.hidden = alanGizli;
  }

  // Bekleyen adet değişikliklerini tek /cart/update.js isteğiyle gönderir.
  // Gönderilecek değerler iş SIRASI GELİNCE okunur: yoldaki istek dönerken
  // yapılan basışlar bir sonraki isteğe toplanır.
  function bekleyenleriGonder() {
    clearTimeout(gonderZamanlayici);
    gonderZamanlayici = null;
    if (!istenenAdet.size) { durumGuncelle(); return; }
    degisiklikSurumu++;
    siraya(() => {
      if (!istenenAdet.size) return null;
      const updates = {};
      istenenAdet.forEach((adet, key) => { updates[key] = adet; });
      const islendi = () => Object.keys(updates).forEach(k => { if (istenenAdet.get(k) === updates[k]) istenenAdet.delete(k); });
      return sepetIstegi('cart/update.js', { updates }).then(cart => {
        islendi();
        // Stok yetmezse Shopify adedi düşürür: müşteriye söylenir
        const eksik = (cart.items || []).find(i => updates[i.key] > i.quantity && !istenenAdet.has(i.key));
        mesajGoster(eksik ? 'Stokta yeterli ürün yok: bu üründen en fazla ' + eksik.quantity + ' adet alabilirsin.' : '');
        sepetiAl(cart);
      }, hata => {
        islendi(); // olmayan değişiklik ekranda kalmasın: sunucudaki hale dönülür
        mesajGoster(hata.message);
        return sepetIstegi('cart.js').then(sepetiAl, () => renderCart());
      });
    });
  }

  function adetDegistir(key, yeni) {
    const adet = Math.max(0, yeni);
    istenenAdet.set(key, adet);
    mesajGoster('');
    renderCart();
    clearTimeout(gonderZamanlayici);
    gonderZamanlayici = null;
    // Satır kalktıysa beklemeden gönder; +/- basışları kısa süre toplanır
    if (adet === 0) bekleyenleriGonder();
    else gonderZamanlayici = setTimeout(bekleyenleriGonder, 350);
    durumGuncelle();
  }

  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', (e) => {
      const btn = e.target.closest ? e.target.closest('button[data-action]') : null;
      const satir = btn ? btn.closest('.cart-item') : null;
      if (!satir || !sunucuSepeti) return;
      const key = satir.dataset.line;
      const item = sunucuSepeti.items.find(i => i.key === key);
      if (!item) return;
      const simdiki = istenenAdet.has(key) ? istenenAdet.get(key) : item.quantity;
      const action = btn.dataset.action;
      adetDegistir(key, action === 'remove' ? 0 : action === 'inc' ? simdiki + 1 : simdiki - 1);
    });
  }

  // "Ekle": seçilen varyasyon + adet gerçek sepete eklenir (/cart/add.js),
  // ardından çekmece sepetin yeni haliyle çizilir. Ekleme sürerken ikinci
  // basış yok sayılır; eklenen ürün sepette olduğu için satırı gizlenir.
  function ekUrunEkle(row, btn) {
    if (row.classList.contains('is-busy')) return;
    const d = upsellDurum(row);
    if (!d.id) { mesajGoster('Lütfen bir seçenek seç.'); return; }
    row.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    mesajGoster('');
    bekleyenleriGonder(); // önce bekleyen adet değişiklikleri gitsin (sıra korunur)
    degisiklikSurumu++;
    siraya(() => sepetIstegi('cart/add.js', { items: [{ id: d.id, quantity: d.qty }] }).then(() => {
      yeniEklenenler.add(row.dataset.productId);
      upsellAdetYaz(row, 1);
      return sepetIstegi('cart.js').then(sepetiAl, () => { renderCart(); setTimeout(refreshCart, 1500); });
    }, hata => {
      mesajGoster(hata.message);
    })).finally(() => {
      row.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
    });
  }

  cartUpsellRows.forEach(row => {
    const select = row.querySelector('[data-upsell-variant]');
    const ekle = row.querySelector('[data-upsell-add]');
    upsellAdetYaz(row, 1);
    if (select) {
      upsellVaryasyonGoster(row);
      select.addEventListener('change', () => upsellVaryasyonGoster(row));
    }
    row.querySelectorAll('[data-upsell-step]').forEach(b => {
      b.addEventListener('click', () => upsellAdetYaz(row, upsellDurum(row).qty + parseInt(b.dataset.upsellStep, 10)));
    });
    if (ekle) ekle.addEventListener('click', () => ekUrunEkle(row, ekle));
  });

  if (cartDrawer) {
    // EasySell'in gömülü formu belgedeki her 'change' olayında sepeti ürün
    // sayfasındaki seçimle yeniden kuruyor. Çekmecedeki seçim kutusu (ek ürün
    // varyasyonu) bunu tetiklemesin: olay çekmecenin dışına çıkmaz.
    cartDrawer.addEventListener('change', (e) => e.stopPropagation());

    // "Ödemeye geç" ve kapıda ödeme (EasySell çekmece butonu): gönderilmemiş
    // adet değişikliği ya da süren bir ekleme varsa önce o biter, sonra aynı
    // tıklama tekrarlanır. Form ve ödeme sayfası sepetin SON halini görür.
    let bekleyenTiklama = null;
    document.addEventListener('click', (e) => {
      if (!sepetMesgul()) return;
      const hedef = e.target && e.target.closest ? e.target.closest('a[href*="/checkout"], [name="checkout"], .es-popup-button, #es-popup-button') : null;
      if (!hedef || !cartDrawer.contains(hedef)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (gonderZamanlayici !== null) bekleyenleriGonder();
      // Beklerken art arda basılırsa form/ödeme yine tek kez açılır
      if (bekleyenTiklama) { bekleyenTiklama = hedef; return; }
      bekleyenTiklama = hedef;
      bosalinca.push(() => { const h = bekleyenTiklama; bekleyenTiklama = null; if (h) h.click(); });
    }, true);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  // ============ PRODUCT PAGE ============
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {

    // Gallery (thumbnail click + mobile touch swipe on main image + video playback)
    const mainImgEl = document.querySelector('[data-main-img]');
    const mainVideoEl = document.querySelector('[data-main-video]');
    const zoomHintEl = document.querySelector('.product__zoom-hint');
    const allThumbs = Array.from(document.querySelectorAll('[data-thumb]'));
    const thumbsStrip = document.querySelector('.product__thumbnails');

    function activateThumb(thumb) {
      if (!thumb) return;
      const mediaType = thumb.dataset.mediaType || 'image';
      const videoSrc = thumb.dataset.videoSrc || '';

      if (mediaType === 'video' && mainVideoEl && videoSrc) {
        if (mainImgEl) mainImgEl.hidden = true;
        if (zoomHintEl) zoomHintEl.hidden = true;
        mainVideoEl.hidden = false;
        if (thumb.dataset.thumb) mainVideoEl.poster = thumb.dataset.thumb;
        if (mainVideoEl.getAttribute('src') !== videoSrc) {
          mainVideoEl.src = videoSrc;
          mainVideoEl.load();
        }
        const playPromise = mainVideoEl.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      } else if (mainImgEl) {
        if (mainVideoEl) {
          try { mainVideoEl.pause(); } catch (e) {}
          mainVideoEl.hidden = true;
        }
        mainImgEl.hidden = false;
        if (zoomHintEl) zoomHintEl.hidden = false;
        if (thumb.dataset.thumb) mainImgEl.src = thumb.dataset.thumb;
      }

      allThumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (thumbsStrip && thumbsStrip.scrollWidth > thumbsStrip.clientWidth) {
        const targetLeft = thumb.offsetLeft - (thumbsStrip.clientWidth / 2) + (thumb.clientWidth / 2);
        thumbsStrip.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
    }

    allThumbs.forEach(thumb => {
      thumb.addEventListener('click', () => activateThumb(thumb));
    });

    const mainImageBox = document.querySelector('.product__main-image');
    if (mainImageBox && allThumbs.length > 1) {
      let gTouchX = null;
      let gTouchY = null;
      let gSwiped = false;
      mainImageBox.addEventListener('touchstart', (e) => {
        if (!e.touches || !e.touches[0]) return;
        gTouchX = e.touches[0].clientX;
        gTouchY = e.touches[0].clientY;
        gSwiped = false;
      }, { passive: true });
      mainImageBox.addEventListener('touchend', (e) => {
        if (gTouchX === null || !e.changedTouches || !e.changedTouches[0]) return;
        const dx = e.changedTouches[0].clientX - gTouchX;
        const dy = e.changedTouches[0].clientY - gTouchY;
        gTouchX = null;
        gTouchY = null;
        if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          gSwiped = true;
          const curIdx = Math.max(0, allThumbs.findIndex(t => t.classList.contains('is-active')));
          const nextIdx = (curIdx + (dx < 0 ? 1 : -1) + allThumbs.length) % allThumbs.length;
          activateThumb(allThumbs[nextIdx]);
        }
      }, { passive: true });
      mainImageBox.addEventListener('click', (e) => {
        if (gSwiped) {
          e.stopImmediatePropagation();
          e.preventDefault();
          gSwiped = false;
        }
      }, true);
    }

    // ============================================================
    // VARIANT SELECTION — bundle-farkında, adet başına bağımsız seçim
    // ============================================================
    // Ürünün varyasyonu varsa (renk, model vb.), seçilen bundle kaç adetse
    // o kadar bağımsız varyasyon seçici üretilir: "1. Ürün", "2. Ürün" ...
    // Her adet kendi rengini/varyasyonunu seçebilir, diğerlerine dokunmaz.
    // ============================================================

    const productRoot = productForm.closest('.product__info') || productForm.parentElement;
    const variantTemplate = productRoot.querySelector('[data-variant-template]');
    const unitsContainer = productRoot.querySelector('[data-variant-units]');
    const unitsWrap = productRoot.querySelector('[data-variant-units-wrap]');
    const variantIdInput = productForm.querySelector('input[name="id"]');
    const variantsData = window.productVariants || [];
    const priceEl = document.querySelector('[data-product-price]');
    const comparePriceEl = document.querySelector('[data-product-compare-price]');
    const atcButton = productForm.querySelector('[data-atc]');
    const atcPriceEl = productForm.querySelector('[data-atc-price]');
    const hasVariantOptions = !!(variantTemplate && unitsContainer);
    // Quantity (varyasyonsuz ürünlerde bundle adedi burada tutulur)
    const qtyInput = productForm.querySelector('[data-qty]');

    // Tek adet bundle fiyatı için kart referansları (bundle modülünde dolduruluyor)
    let activeBundle = { qty: 1, finalCents: null, compareCents: null };
    let units = []; // [{ index, el }]
    let atcBusy = false; // "EKLENİYOR..." sürerken ikinci gönderimi engeller

    const bundlesWrap = document.querySelector('[data-bundles-wrap]');

    // Harici paket uygulaması ("Çok Al & Az Öde" / Pumper / EasySell QB / Kaching) kontrolü
    function hariciPaketUygulamasiVarMi() {
      if (!productRoot) return false;
      if (productRoot.querySelector('#pumper_bundles, [id*="pumper"], [class*="pumper"], [class*="prvw__"], [class*="kaching"], .es-qty-breaks, #es-qty-breaks, [class*="es-qb"]')) {
        return true;
      }
      const radios = productRoot.querySelectorAll('input[type="radio"]');
      for (let i = 0; i < radios.length; i++) {
        if (!radios[i].closest('[data-bundles-wrap], [data-upsell]')) return true;
      }
      return false;
    }

    function temaPaketAktifMi() {
      if (!bundlesWrap || bundlesWrap.hidden || bundlesWrap.style.display === 'none') return false;
      if (hariciPaketUygulamasiVarMi()) {
        bundlesWrap.style.display = 'none';
        return false;
      }
      return !!bundlesWrap.querySelector('[data-bundle]');
    }

    // Seçim alanını (heading + adet satırları) o an aktif olan paket kartının
    // İÇİNE taşır. Tema paketleri kapalıysa varyasyon seçiciyi doğrudan görünür kılar.
    function mountUnitsIntoActiveCard() {
      if (!hasVariantOptions || !unitsWrap) return;
      const activeCard = document.querySelector('[data-bundle].is-active');
      if (activeCard && temaPaketAktifMi()) {
        activeCard.appendChild(unitsWrap);
        unitsWrap.classList.add('is-visible');
      } else {
        const pickerWrap = productRoot.querySelector('[data-variant-picker-wrap]');
        if (pickerWrap) pickerWrap.style.display = 'block';
        unitsWrap.classList.add('is-visible');
      }
    }

    function getSelectedOptionsIn(root) {
      const groups = root.querySelectorAll('[data-variant-group]');
      const selected = [];
      groups.forEach(group => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const select = group.querySelector('.uvar__select');
        selected[pos - 1] = select && select.value ? select.value : null;
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      if (variantsData.length === 1) return variantsData[0];
      return variantsData.find(v => {
        if (!v.options || v.options.length !== selected.length) return false;
        return selected.every((val, idx) => val !== null && String(v.options[idx]) === String(val));
      }) || null;
    }

    function getUnitVariant(unitEl) {
      return findMatchingVariant(getSelectedOptionsIn(unitEl));
    }

    // Stoktaki her seçenek kombinasyonunu kontrol eder; tükenmiş/olmayan
    // seçenekleri <select> içinde devre dışı bırakır ve "(Tükendi)" etiketler.
    function updateOptionAvailabilityIn(root) {
      const selected = getSelectedOptionsIn(root);
      root.querySelectorAll('.uvar__select').forEach(select => {
        const pos = parseInt(select.dataset.optionPosition, 10);
        Array.from(select.options).forEach(opt => {
          const probe = selected.slice();
          probe[pos - 1] = opt.value;
          const available = variantsData.some(v => {
            if (!v.options || v.options.length !== probe.length) return false;
            return probe.every((pv, idx) => pv === null || String(v.options[idx]) === String(pv)) && v.available;
          });
          opt.disabled = !available;
          opt.textContent = available ? opt.value : `${opt.value} (Tükendi)`;
        });
      });
    }

    function formatPricing(finalCents, compareCents) {
      if (priceEl) priceEl.textContent = formatMoney(finalCents);
      if (comparePriceEl) {
        if (compareCents && compareCents > finalCents) {
          comparePriceEl.textContent = formatMoney(compareCents);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (atcPriceEl) atcPriceEl.textContent = formatMoney(finalCents);
    }

    // Adet rozetini (numara ⇄ hata) ve seçenek stok durumunu günceller
    function updateUnitBadge(unitEl) {
      const badge = unitEl.querySelector('.uvar__badge');
      if (!badge) return;
      const v = getUnitVariant(unitEl);
      badge.classList.toggle('is-error', !v);
    }

    // Tek bir adetin varyasyon durumunu tazele (tükenmiş seçenekler + hata rozeti)
    function refreshUnit(unitEl) {
      updateOptionAvailabilityIn(unitEl);
      updateUnitBadge(unitEl);
      if (getUnitVariant(unitEl)) unitEl.classList.remove('has-error');
    }

    // Eksik seçim yapılmış ilk adedi bulur; tüm adetleri hata durumuna göre işaretler
    function validateUnits() {
      let firstInvalid = null;
      units.forEach(u => {
        const ok = !!getUnitVariant(u.el);
        u.el.classList.toggle('has-error', !ok);
        if (!ok && !firstInvalid) firstInvalid = u.el;
      });
      return firstInvalid;
    }

    // Sepete ekle butonunun altında kısa ömürlü bir uyarı mesajı gösterir
    let formMessageTimer = null;
    function showFormMessage(msg) {
      const el = productForm.querySelector('[data-form-message]');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('is-visible');
      clearTimeout(formMessageTimer);
      formMessageTimer = setTimeout(() => el.classList.remove('is-visible'), 4000);
    }

    // Fiyat + Sepete Ekle butonunun genel durumunu tazele
    function updatePricingAndATC() {
      const qty = hasVariantOptions ? (units.length || 1) : (parseInt(productForm.querySelector('[data-qty]')?.value || 1, 10));

      let allMatched = true;
      let allAvailable = true;
      let firstVariant = null;

      if (hasVariantOptions) {
        units.forEach((u, idx) => {
          const v = getUnitVariant(u.el);
          if (idx === 0) firstVariant = v;
          if (!v) { allMatched = false; allAvailable = false; }
          else if (!v.available) { allAvailable = false; }
        });
      } else {
        firstVariant = variantsData[0] || null;
        allAvailable = firstVariant ? firstVariant.available : false;
      }

      // Formdaki gizli varyasyon alanı (input[name="id"]) seçimle eşitlenir.
      // Eskiden varyasyonlu üründe hiç yazılmıyordu: 2. rengi seçip kapıda
      // ödeme butonuna basınca formda 1. renk çıkıyordu. EasySell bu alanı
      // önce value ÖZNİTELİĞİNDEN (getAttribute) okuyor; ikisi birden yazılır.
      if (variantIdInput && firstVariant) {
        variantIdInput.value = firstVariant.id;
        variantIdInput.setAttribute('value', firstVariant.id);

        // Shopify / Meta Katalog Pixel için aktif varyant meta etiketlerini eşitle
        const retailerMeta = document.querySelector('meta[property="product:retailer_item_id"]');
        if (retailerMeta) retailerMeta.setAttribute('content', String(firstVariant.id));
        const unitIsoPrice = (Number(firstVariant.price || 0) / 100).toFixed(2);
        document.querySelectorAll('meta[property="og:price:amount"], meta[property="product:price:amount"]').forEach(m => {
          m.setAttribute('content', unitIsoPrice);
        });
        document.querySelectorAll('meta[property="product:availability"], meta[property="og:availability"]').forEach(m => {
          m.setAttribute('content', firstVariant.available ? 'in stock' : 'out of stock');
        });
      }
      if (qtyInput) qtyInput.setAttribute('value', qtyInput.value);

      let finalCents, compareCents;
      if (activeBundle.finalCents) {
        finalCents = activeBundle.finalCents;
        compareCents = activeBundle.compareCents;
      } else if (firstVariant) {
        finalCents = firstVariant.price * qty;
        compareCents = (firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price)
          ? firstVariant.compare_at_price * qty
          : null;
      } else {
        const fallback = variantsData[0];
        finalCents = fallback ? fallback.price * qty : 0;
        compareCents = null;
      }
      formatPricing(finalCents, compareCents);

      if (atcButton && !atcBusy) {
        const isAvailable = allMatched && allAvailable;
        // Gerçek "disabled" SADECE seçim gerçekten tükendiyse. EasySell bu
        // butonun disabled / aria-disabled durumunu kapıda ödeme butonuna
        // kopyalayıp onu "tükendi" yapıyor. "Seçim yapın" durumunda buton
        // tıklanabilir kalır; eksik seçim tıklama anında uyarılır.
        atcButton.disabled = allMatched && !allAvailable;
        atcButton.classList.toggle('is-pending', !allMatched);
        const textEl = atcButton.querySelector('.atc-text');
        if (textEl) {
          textEl.textContent = isAvailable
            ? (atcButton.dataset.atcText || 'SEPETE EKLE')
            : (allMatched ? 'TÜKENDİ' : 'LÜTFEN SEÇİM YAPIN');
        }
      }

      sepetiEsitle();
    }

    // "Tümüne uygula" — 1. ürünün seçimini diğer tüm adetlere kopyalar.
    // Adet sayısı arttıkça tek tek seçim yapma sürtünmesini azaltır.
    function applyFirstUnitToAll() {
      if (units.length < 2) return;
      const sourceSelects = units[0].el.querySelectorAll('.uvar__select');
      const sourceValues = Array.from(sourceSelects).map(s => ({ pos: s.dataset.optionPosition, value: s.value }));
      units.slice(1).forEach(u => {
        sourceValues.forEach(({ pos, value }) => {
          if (!value) return;
          const select = u.el.querySelector(`.uvar__select[data-option-position="${pos}"]`);
          if (select && select.value !== value) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    // Şablondan bir "adet" varyasyon satırı üretir; select id/name'lerini
    // adete özgü hale getirip diğer adetlerden tamamen izole eder.
    function buildUnit(unitIndex, totalUnits) {
      const wrapper = document.createElement('div');
      wrapper.className = 'uvar__row';
      wrapper.dataset.unit = unitIndex;

      if (totalUnits > 1) {
        const badge = document.createElement('span');
        badge.className = 'uvar__badge';
        badge.textContent = '#' + unitIndex;
        wrapper.appendChild(badge);
      }

      const fieldsWrap = document.createElement('div');
      fieldsWrap.className = 'uvar__fields';

      const clone = variantTemplate.content.cloneNode(true);
      clone.querySelectorAll('.uvar__select').forEach(select => {
        select.id = `u${unitIndex}-opt-${select.dataset.optionPosition}`;
        select.name = `u${unitIndex}-option-${select.dataset.optionPosition}`;
        select.dataset.unit = unitIndex;
      });
      fieldsWrap.appendChild(clone);
      wrapper.appendChild(fieldsWrap);

      wrapper.querySelectorAll('.uvar__select').forEach(select => {
        select.addEventListener('change', () => {
          refreshUnit(wrapper);
          updatePricingAndATC();
        });
        // Dropdown açılırken kartın kendisinin yeniden seçilmesini/kapanmasını tetiklememesi için
        select.addEventListener('click', (e) => e.stopPropagation());
      });

      return wrapper;
    }

    function renderUnits(qty) {
      if (!hasVariantOptions) return;
      unitsContainer.innerHTML = '';
      units = [];
      const safeQty = Math.max(1, qty || 1);

      if (safeQty > 1) {
        const applyRow = document.createElement('button');
        applyRow.type = 'button';
        applyRow.className = 'uvar__apply-all';
        applyRow.textContent = 'Aynı seçimi tüm ürünlere uygula';
        applyRow.addEventListener('click', (e) => { e.stopPropagation(); applyFirstUnitToAll(); });
        unitsContainer.appendChild(applyRow);
      }

      for (let i = 1; i <= safeQty; i++) {
        const unitEl = buildUnit(i, safeQty);
        unitsContainer.appendChild(unitEl);
        units.push({ index: i, el: unitEl });
      }

      units.forEach(u => refreshUnit(u.el));
      updatePricingAndATC();
      mountUnitsIntoActiveCard();
    }

    // ============================================================
    // BUNDLE selector — adet değiştikçe varyasyon seçicileri de yeniden üretilir
    // ve seçim kutusu tıklanan kartın içine taşınır.
    // Kart artık <button> değil <div role="radio">; tıklama sadece kartın
    // üst satırına (.bundle-card__row) bağlı — böylece karta taşınan
    // <select> elemanlarına tıklamak yanlışlıkla kartı yeniden tetiklemez.
    // ============================================================
    function selectBundle(card) {
      document.querySelectorAll('[data-bundle]').forEach(c => {
        c.classList.remove('is-active');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('is-active');
      card.setAttribute('aria-checked', 'true');

      const qty = parseInt(card.dataset.bundle, 10) || 1;
      const finalCents = parseInt(card.dataset.bundleFinal, 10) || null;
      const compareCents = parseInt(card.dataset.bundleCompare, 10) || null;

      activeBundle = { qty, finalCents, compareCents };

      if (qtyInput) qtyInput.value = qty;
      if (hasVariantOptions) {
        renderUnits(qty); // renderUnits, seçim kutusunu bu karta taşımayı da yapar
      } else {
        updatePricingAndATC();
      }
    }

    document.querySelectorAll('[data-bundle]').forEach(card => {
      const row = card.querySelector('.bundle-card__row') || card;
      row.addEventListener('click', () => selectBundle(card));
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          selectBundle(card);
        }
      });
    });

    // ============================================================
    // EK ÜRÜNLER ("Siparişine ekle") — paket kartlarının altındaki satırlar
    // ============================================================
    // İşaretli her satır { seçilen varyasyon, adet } olarak sayfa seçimine
    // eklenir. Adet 1 ile satıcının belirlediği üst sınır arasındadır;
    // işaretsiz satır = 0 (hiç eklenmez).
    // ============================================================
    const upsellRoot = productRoot.querySelector('[data-upsell]');
    const upsellRows = upsellRoot ? Array.from(upsellRoot.querySelectorAll('[data-upsell-row]')) : [];
    // Satır yardımcıları (upsellDurum, upsellAdetYaz, upsellVaryasyonGoster)
    // sepet çekmecesiyle ortak: dosyanın başında "EK ÜRÜN SATIRI".

    upsellRows.forEach(row => {
      const check = row.querySelector('[data-upsell-check]');
      const select = row.querySelector('[data-upsell-variant]');
      if (!check) return;

      // Geri tuşuyla dönüşte tarayıcı kutuyu/seçimi geri yükleyebilir
      upsellAdetYaz(row, 1);
      if (select) upsellVaryasyonGoster(row);
      row.classList.toggle('is-checked', check.checked);

      check.addEventListener('change', () => {
        row.classList.toggle('is-checked', check.checked);
        if (!check.checked) upsellAdetYaz(row, 1); // tekrar işaretlenince 1'den başlar
        sepetiEsitle();
      });

      // Varyasyon seçmek "bunu istiyorum" demek: satır kendiliğinden işaretlenir
      if (select) {
        select.addEventListener('change', () => {
          upsellVaryasyonGoster(row);
          if (!check.checked) {
            check.checked = true;
            row.classList.add('is-checked');
          }
          sepetiEsitle();
        });
      }

      row.querySelectorAll('[data-upsell-step]').forEach(b => {
        b.addEventListener('click', () => {
          upsellAdetYaz(row, upsellDurum(row).qty + parseInt(b.dataset.upsellStep, 10));
          sepetiEsitle();
        });
      });

      // Satırın boş bir yerine (görsel, ad, fiyat) dokunmak kutuyu açar/kapatır
      row.addEventListener('click', (e) => {
        if (e.target.closest('input, select, button, a, .upsell__opt, .upsell__qty')) return;
        check.click();
      });
    });

    // ============================================================
    // SAYFA SEÇİMİ → SEPET SATIRLARI (Sepete Ekle + EasySell ortak)
    // ============================================================
    // Paketteki her adet kendi varyasyonuyla sayılır (aynı varyasyonlar tek
    // satırda birleşir) + işaretli ek ürünler. Varyasyonu eşleşmeyen (eksik
    // seçimli) ilk adet de döner.
    // Harici "Çok Al & Az Öde" (EasySell QB / Pumper / Kaching) radyo butonundan seçili adedi okur
    function hariciSeciliAdetGetir() {
      if (!productRoot) return null;
      const checkedRadio = Array.from(productRoot.querySelectorAll('input[type="radio"]:checked')).find(
        r => !r.closest('[data-bundles-wrap], [data-upsell]')
      );
      if (checkedRadio) {
        const attrQty = parseInt(checkedRadio.dataset.quantity || checkedRadio.dataset.qty || checkedRadio.getAttribute('quantity') || '', 10);
        if (attrQty > 0 && attrQty <= 50) return attrQty;
        const valQty = parseInt(checkedRadio.value, 10);
        if (valQty > 0 && valQty <= 20 && String(valQty) === String(checkedRadio.value).trim()) return valQty;
        const container = checkedRadio.closest('label, tr, li, [class*="tier"], [class*="offer"], [class*="bundle"], [class*="item"], div') || checkedRadio.parentElement;
        const text = (container && container.textContent) || '';
        const m = text.match(/(\d+)\s*adet/i);
        if (m && parseInt(m[1], 10) > 0) return parseInt(m[1], 10);
      }
      return null;
    }

    // Harici paket radyo butonları değiştiğinde gizli quantity alanını da eşitle
    if (productRoot) {
      productRoot.addEventListener('change', (e) => {
        if (e.target && e.target.matches && e.target.matches('input[type="radio"]') && !e.target.closest('[data-bundles-wrap], [data-upsell]')) {
          const q = hariciSeciliAdetGetir();
          if (q && qtyInput) {
            qtyInput.value = q;
            qtyInput.setAttribute('value', q);
          }
        }
      });
    }

    function sayfaSecimi() {
      const adetler = new Map();
      let eksik = null;
      const ekle = (id, q) => {
        const numId = parseInt(id, 10);
        const numQ = parseInt(q, 10);
        if (!numId || !(numQ > 0)) return;
        adetler.set(numId, (adetler.get(numId) || 0) + numQ);
      };

      const temaAktif = temaPaketAktifMi();

      if (temaAktif) {
        if (hasVariantOptions) {
          units.forEach(u => {
            const v = getUnitVariant(u.el);
            if (v) ekle(v.id, 1);
            else if (!eksik) eksik = u.el;
          });
        } else {
          const id = parseInt(variantIdInput?.value || (variantsData[0] && variantsData[0].id), 10);
          ekle(id, parseInt(qtyInput?.value || activeBundle.qty || 1, 10));
        }
      } else {
        // Tema paketleri kapalıysa veya "Çok Al & Az Öde" uygulaması aktifse:
        // 1) Uygulama window.pmpr_cart_item dizisini kendisi doldurduysa onu kullan
        if (!window.__themeWrotePmpr && Array.isArray(window.pmpr_cart_item) && window.pmpr_cart_item.length > 0) {
          window.pmpr_cart_item.forEach(it => {
            if (it && (it.id || it.variant_id)) {
              ekle(it.id || it.variant_id, it.quantity || 1);
            }
          });
        }
        // 2) Henüz eklenmediyse seçili varyasyon + harici paket adedini ("2 Adet" vb.) kullan
        if (adetler.size === 0) {
          const disAdet = hariciSeciliAdetGetir() || parseInt(qtyInput?.value, 10) || 1;
          if (hasVariantOptions && units.length > 0) {
            const v = getUnitVariant(units[0].el) || variantsData[0];
            if (v) ekle(v.id, disAdet);
          } else {
            const id = parseInt(variantIdInput?.value || (variantsData[0] && variantsData[0].id), 10);
            ekle(id, disAdet);
          }
        }
      }

      upsellRows.forEach(row => {
        const d = upsellDurum(row);
        if (d.checked) ekle(d.id, d.qty);
      });
      return { items: Array.from(adetler, ([id, quantity]) => ({ id, quantity })), eksik };
    }

    // Eksik seçimi gösterir: işaretler, oraya kaydırır, kısa uyarı verir
    function eksikSecimiGoster(unitEl) {
      validateUnits();
      unitEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      unitEl.classList.add('shake');
      setTimeout(() => unitEl.classList.remove('shake'), 500);
      showFormMessage('Lütfen işaretli ürün(ler) için bir seçim yap.');
    }

    // EasySell (kapıda ödeme formu): Yalnızca temanın kendi paket/upsell seçimi
    // kullanılıyorsa window.pmpr_cart_item yazılır; harici "Çok Al & Az Öde"
    // uygulaması varsa onun kendi seçimine müdahale edilmez.
    let sonSecimImza = null;
    function sepetiEsitle() {
      const upsellSecili = upsellRows.some(r => upsellDurum(r).checked);
      if (!temaPaketAktifMi() && !upsellSecili) return;
      const { items } = sayfaSecimi();
      window.__themeWrotePmpr = true;
      window.pmpr_cart_item = items;
      const imza = JSON.stringify(items);
      if (sonSecimImza !== null && imza !== sonSecimImza && qtyInput) {
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sonSecimImza = imza;
    }

    // EasySell modalının her zaman doğrudan <body> altında ve ekran ortasında açılmasını garanti et
    function easysellModalMerkezle() {
      if (hariciPaketUygulamasiVarMi()) {
        if (bundlesWrap && bundlesWrap.style.display !== 'none') {
          bundlesWrap.style.display = 'none';
        }
        if (window.__themeWrotePmpr && !upsellRows.some(r => upsellDurum(r).checked)) {
          delete window.pmpr_cart_item;
          window.__themeWrotePmpr = false;
        }
      }
      const modal = document.getElementById('easysell-modal') || document.querySelector('.es-modal');
      if (!modal) return;
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.scrollTop = 0;
    }
    if ('MutationObserver' in window) {
      const esObserver = new MutationObserver(() => easysellModalMerkezle());
      esObserver.observe(document.body, { childList: true, subtree: true });
    }

    // EasySell butonlarına basıldığı an — EasySell'in kendi dinleyicisinden
    // ÖNCE (capture) — tema paketi aktifse seçim yazılır.
    const ES_BUTONLARI = '.es-popup-button, #es-popup-button, .es-popup-button-overwrite, #es-popup-button-overwrite, [href="#es-popup-button-overwrite"], .es-sticky, #es-sticky, #es-form-button';
    document.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest ? e.target.closest(ES_BUTONLARI) : null;
      if (!btn || btn.closest('.es-popup-button-drawer')) return;
      if (btn.id === 'es-form-button' && btn.closest('#easysell-modal')) return;

      const upsellSecili = upsellRows.some(r => upsellDurum(r).checked);
      if (temaPaketAktifMi() || upsellSecili) {
        const { items, eksik } = sayfaSecimi();
        if (eksik) {
          e.preventDefault();
          e.stopImmediatePropagation();
          eksikSecimiGoster(eksik);
          return;
        }
        window.__themeWrotePmpr = true;
        window.pmpr_cart_item = items;
      }
      setTimeout(easysellModalMerkezle, 20);
      setTimeout(easysellModalMerkezle, 150);
    }, true);

    // İlk aktif bundle kartının adedini/fiyatını yakala
    const initialActiveBundle = document.querySelector('[data-bundle].is-active');
    if (initialActiveBundle && temaPaketAktifMi()) {
      activeBundle = {
        qty: parseInt(initialActiveBundle.dataset.bundle, 10) || 1,
        finalCents: parseInt(initialActiveBundle.dataset.bundleFinal, 10) || null,
        compareCents: parseInt(initialActiveBundle.dataset.bundleCompare, 10) || null
      };
      if (qtyInput) qtyInput.value = activeBundle.qty;
    }

    if (hasVariantOptions) {
      renderUnits(temaPaketAktifMi() ? activeBundle.qty : 1);
    } else {
      updatePricingAndATC();
    }

    // ATC submit — paketteki adetler ve işaretli ek ürünler tek istekte sepete eklenir
    // ve sepet çekmecesi anında güncel içerikle açılır.
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      if (atcBusy) return;

      const { items, eksik } = sayfaSecimi();
      if (eksik) {
        eksikSecimiGoster(eksik);
        return;
      }
      if (!items.length) return;

      atcBusy = true;
      if (atcButton) atcButton.classList.add('is-busy');
      const textEl = atcButton ? atcButton.querySelector('.atc-text') : null;
      if (textEl) textEl.textContent = 'EKLENİYOR...';
      const bitir = () => {
        atcBusy = false;
        if (atcButton) atcButton.classList.remove('is-busy');
        updatePricingAndATC();
      };

      degisiklikSurumu++;
      siraya(() => sepetIstegi('cart/add.js', { items })
        .then(() => sepetIstegi('cart.js'))
        .then(cart => {
          sepetiAl(cart);
          if (textEl) textEl.textContent = '✓ SEPETE EKLENDİ';
          setTimeout(bitir, 1500);
          openCart();
        })
        .catch((err) => {
          bitir();
          showFormMessage((err && (err.message || err.description)) || 'Sepete eklenemedi, lütfen tekrar deneyin.');
        })
      );
    });
  }

  // ============ STICKY ATC ============
  const stickyAtc = document.querySelector('.sticky-atc');
  if (stickyAtc && productForm) {
    document.body.classList.add('has-sticky-atc');
    const atcButton = productForm.querySelector('[data-atc]');
    const stickyBtn = stickyAtc.querySelector('.sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        atcButton?.click();
        atcButton?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    const heroAtc = productForm.querySelector('[data-atc]');
    if (heroAtc && 'IntersectionObserver' in window) {
      const atcObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      atcObserver.observe(heroAtc);
    }
  }

  // ============ PROMO BANNER CTA → Sepete Ekle alanına kaydır ============
  document.querySelectorAll('[data-scroll-atc]').forEach(btn => {
    btn.addEventListener('click', () => {
      const atc = document.querySelector('[data-atc]');
      if (atc) {
        atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        atc.classList.add('shake');
        setTimeout(() => atc.classList.remove('shake'), 500);
      }
    });
  });

  // ============ CONTENT TABS ============
  document.querySelectorAll('[data-tabs]').forEach(container => {
    const buttons = container.querySelectorAll('[data-tab-btn]');
    const panes = container.querySelectorAll('[data-tab-pane]');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('is-active'));
        panes.forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        const target = container.querySelector(`[data-tab-pane="${btn.dataset.tabBtn}"]`);
        if (target) target.classList.add('is-active');
      });
    });
  });

  // ============ VIDEO POSTER PLAY ============
  document.querySelectorAll('[data-video-poster]').forEach(poster => {
    poster.addEventListener('click', () => {
      const videoId = poster.dataset.videoId;
      const provider = poster.dataset.videoProvider || 'youtube';
      let src = '';
      if (provider === 'youtube') src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      else if (provider === 'vimeo') src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      poster.parentNode.appendChild(iframe);
      poster.style.display = 'none';
    });
  });

  // ============ Initial cart count ============
  // Tek /cart.js isteği hem sayacı hem çekmeceyi hazırlar: çekmece açılınca
  // önce "Sepetiniz boş" görünüp sonra ürünlerin gelmesi (yanıp sönme) olmaz.
  refreshCart();

})();

/* ============================================================
   GÖRSEL BÜYÜTME (lightbox)
   Ürün fotoğrafına tıklayınca tam ekran açar. Küçük görsellerden
   geçiş yapılabilir; ok tuşları ve ESC çalışır.
   Bağımlılık yok, ~60 satır. Klavye ve ekran okuyucu için erişilebilir.
   ============================================================ */
(function () {
  'use strict';
  var tetik = document.querySelector('[data-zoomable]');
  if (!tetik) return;

  var kaynaklar = [];
  var anaImg = document.querySelector('[data-main-img]');
  var anaVideo = document.querySelector('[data-main-video]');
  if (anaImg && !anaImg.hidden) kaynaklar.push(anaImg.getAttribute('src'));
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    if (t.dataset.mediaType === 'video' || t.dataset.mediaType === 'external_video') return;
    var u = t.dataset.thumb;
    if (u && kaynaklar.indexOf(u) === -1) kaynaklar.push(u);
  });
  if (!kaynaklar.length) return;

  var sira = 0, kutu = null, oncekiOdak = null;

  function goster(i) {
    sira = (i + kaynaklar.length) % kaynaklar.length;
    kutu.querySelector('.lb__img').src = kaynaklar[sira];
    kutu.querySelector('.lb__sayac').textContent = (sira + 1) + ' / ' + kaynaklar.length;
  }

  function kapat() {
    if (!kutu) return;
    kutu.remove(); kutu = null;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', tus);
    if (oncekiOdak) oncekiOdak.focus();
  }

  function tus(e) {
    if (e.key === 'Escape') kapat();
    else if (e.key === 'ArrowRight') goster(sira + 1);
    else if (e.key === 'ArrowLeft') goster(sira - 1);
  }

  function ac(e) {
    if (kutu) return;
    // Video oynatılırken veya video görünürken görsel büyütme kutusunu açma
    if (anaVideo && !anaVideo.hidden) return;
    if (e && e.target && e.target.tagName === 'VIDEO') return;
    oncekiOdak = document.activeElement;
    kutu = document.createElement('div');
    kutu.className = 'lb';
    kutu.setAttribute('role', 'dialog');
    kutu.setAttribute('aria-modal', 'true');
    kutu.setAttribute('aria-label', 'Ürün görseli');
    kutu.innerHTML =
      '<button class="lb__kapat" aria-label="Kapat">&times;</button>' +
      '<button class="lb__ok lb__ok--sol" aria-label="Önceki">&#8249;</button>' +
      '<img class="lb__img" alt="">' +
      '<button class="lb__ok lb__ok--sag" aria-label="Sonraki">&#8250;</button>' +
      '<span class="lb__sayac"></span>';
    document.body.appendChild(kutu);
    document.body.style.overflow = 'hidden';

    var mevcut = anaImg ? kaynaklar.indexOf(anaImg.getAttribute('src')) : 0;
    goster(mevcut === -1 ? 0 : mevcut);

    kutu.querySelector('.lb__kapat').addEventListener('click', kapat);
    kutu.querySelector('.lb__ok--sol').addEventListener('click', function (e) { e.stopPropagation(); goster(sira - 1); });
    kutu.querySelector('.lb__ok--sag').addEventListener('click', function (e) { e.stopPropagation(); goster(sira + 1); });
    kutu.addEventListener('click', function (e) { if (e.target === kutu || e.target.classList.contains('lb__img')) kapat(); });
    document.addEventListener('keydown', tus);
    kutu.querySelector('.lb__kapat').focus();

    // Telefonda parmakla geçiş
    var bas = null;
    kutu.addEventListener('touchstart', function (e) { bas = e.touches[0].clientX; }, { passive: true });
    kutu.addEventListener('touchend', function (e) {
      if (bas === null) return;
      var fark = e.changedTouches[0].clientX - bas;
      if (Math.abs(fark) > 50) goster(sira + (fark < 0 ? 1 : -1));
      bas = null;
    }, { passive: true });
  }

  tetik.addEventListener('click', ac);
  tetik.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ac(); }
  });
})();

/* ============================================================
   ÖNCE / SONRA GÖRSEL KAYDIRICI
   İki fotoğraf üst üste; ortadaki kol sürüklendikçe üstteki kırpılır.
   Fare, dokunmatik ve klavye (ok tuşları) ile çalışır.
   ============================================================ */
(function () {
  'use strict';
  document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
    var frame = slider.querySelector('.baft-slider__frame');
    var clip = slider.querySelector('[data-ba-clip]');
    var handle = slider.querySelector('[data-ba-handle]');
    if (!frame || !clip || !handle) return;

    var oran = 50;
    function uygula(p) {
      oran = Math.max(0, Math.min(100, p));
      clip.style.width = oran + '%';
      handle.style.left = oran + '%';
      handle.setAttribute('aria-valuenow', Math.round(oran));
    }
    uygula(50);

    function konumdan(clientX) {
      var r = frame.getBoundingClientRect();
      if (!r.width) return;
      uygula(((clientX - r.left) / r.width) * 100);
    }

    var suruklu = false;
    function basla(e) {
      suruklu = true;
      frame.classList.add('is-dragging');
      if (e.touches) konumdan(e.touches[0].clientX);
      else konumdan(e.clientX);
    }
    function hareket(e) {
      if (!suruklu) return;
      if (e.touches) konumdan(e.touches[0].clientX);
      else { e.preventDefault(); konumdan(e.clientX); }
    }
    function bitir() { suruklu = false; frame.classList.remove('is-dragging'); }

    handle.addEventListener('mousedown', basla);
    frame.addEventListener('mousedown', basla);
    window.addEventListener('mousemove', hareket);
    window.addEventListener('mouseup', bitir);

    handle.addEventListener('touchstart', basla, { passive: true });
    frame.addEventListener('touchstart', basla, { passive: true });
    window.addEventListener('touchmove', hareket, { passive: true });
    window.addEventListener('touchend', bitir);

    handle.addEventListener('keydown', function (e) {
      var adim = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft') { e.preventDefault(); uygula(oran - adim); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); uygula(oran + adim); }
      else if (e.key === 'Home') { e.preventDefault(); uygula(0); }
      else if (e.key === 'End') { e.preventDefault(); uygula(100); }
    });

    // Görseller yüklendikçe oranı koru
    window.addEventListener('resize', function () { uygula(oran); });
  });
})();

/* ============================================================
   YORUM KARUSELİ — ok butonları
   Kaydırmanın kendisi CSS scroll-snap ile çalışır; bu kod sadece
   masaüstündeki okları bağlar ve uçlara gelince pasifleştirir.
   ============================================================ */
(function () {
  'use strict';
  document.querySelectorAll('[data-tcarousel]').forEach(function (car) {
    var track = car.querySelector('[data-tcar-track]');
    var prev = car.querySelector('[data-tcar-prev]');
    var next = car.querySelector('[data-tcar-next]');
    if (!track || !prev || !next) return;

    function adim() {
      var kart = track.firstElementChild;
      return kart ? kart.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    }
    function durum() {
      var son = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= son;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -adim(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: adim(), behavior: 'smooth' }); });
    track.addEventListener('scroll', durum, { passive: true });
    window.addEventListener('resize', durum);
    durum();
  });
})();

/* ============================================================
   ÜRÜN BAŞLIĞI — kelime bölünmez, punto küçülür
   CSS tireyi kapattı; tek bir kelime yine de satıra sığmıyorsa
   (dar ekran + uzun kelime) yazı boyutu sığana kadar kademeli iner.
   ============================================================ */
(function () {
  'use strict';
  var basliklar = document.querySelectorAll('[data-baslik-sigdir]');
  if (!basliklar.length) return;
  function sigdir(el) {
    el.style.fontSize = '';
    var taban = parseFloat(getComputedStyle(el).fontSize);
    if (!taban) return;
    var boyut = taban;
    var alt = Math.max(15, taban * 0.6);
    var deneme = 0;
    while (el.scrollWidth > el.clientWidth + 1 && boyut > alt && deneme < 12) {
      boyut = boyut * 0.94;
      el.style.fontSize = boyut.toFixed(2) + 'px';
      deneme++;
    }
  }
  function hepsi() { basliklar.forEach(sigdir); }
  hepsi();
  window.addEventListener('load', hepsi);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(hepsi).catch(function () {});
  var zamanlayici;
  window.addEventListener('resize', function () { clearTimeout(zamanlayici); zamanlayici = setTimeout(hepsi, 150); });
})();
